import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';

const toggleUsingReferenceKnowledge = (
    panelList,
    setPanelList,
    panelId,
    tabId,
    setToggleUsingKnowledgeTicketList,
) => {
    setToggleUsingKnowledgeTicketList(prev => {

        const isUsingReferenceKnowledge = !prev;

        if (!Utils.isEmptyArray(panelList) && setPanelList) {
            let currentPanelList = cloneDeep(panelList);
            if (Utils.isEmptyArray(currentPanelList)) return isUsingReferenceKnowledge;
            let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
            if (currentPanelIndex === -1) return isUsingReferenceKnowledge;
            
            let currentPanel = currentPanelList[currentPanelIndex];
            
            if (Utils.isEmptyArray(currentPanel.tabList)) return isUsingReferenceKnowledge;
            let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
            if (currentTabIndex === -1) return isUsingReferenceKnowledge;
            
            // set props: filterKnowledgeListData.resetSearchCondition = !isUsingReferenceKnowledge
            currentPanelList[currentPanelIndex].tabList[
                currentTabIndex
            ].component.props.filterKnowledgeListData.resetSearchCondition = !isUsingReferenceKnowledge;
            setPanelList([...currentPanelList]);
        }

        // set state
        return isUsingReferenceKnowledge;
    });
};

export {
    toggleUsingReferenceKnowledge,
};
